<!--工伤单位-->
<template>
  <div
    class="hbn-container"
    id="userInfo"
  >
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="单位名称">
                  <el-input
                    id="Name"
                    v-model="PageQuery.queryModel.Name"
                    placeholder="单位名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button
              size="mini"
              class="hbn-button-serach"
              @click="seach"
            >查找</el-button>
            <span
              class="control-collapse"
              @click="show = !show"
            >{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          class="custom-button"
          type="primary"
          :icon="Search"
          @click="add"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
        <el-button
          type="primary"
          class="custom-button"
          @click="importExcel"
        >
          <i class="el-icon-upload custom-icon"></i>
          <span>导入</span>
        </el-button>
        <el-button
          type="primary"
          class="custom-button"
          @click="exportExcel"
        >
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template v-for="(item, key) in UnitList" :key="key">
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow"
                show-overflow-tooltip
              />
            </template>

            <vxe-table-column
              width="150"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ rowIndex }">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Modify')"
                >编辑</el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Detail')"
                >查看</el-button>
                <el-popconfirm
                  title="是否要删除?"
                  @confirm="handleClick(rowIndex, 'Delete')"
                >
                  <template #reference>
                    <el-button
                      size="small"
                      type="text"
                    >删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
            <!-- <template #left>
                    <span class="page-left">
                        <span>已选中 {{ checkendSum }}</span>
                        <span class="clear" @click.prevent="$refs.multipleTable.clearCheckboxRow()">清空</span>
                    </span>
                </template> -->
          </vxe-pager>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <InjuryUnitEdit
      ref="InjuryUnitEdit"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-cancel="handleCancel"
      @handle-confirm="handleConfirm"
    ></InjuryUnitEdit>
    <excel
      controlName="InjuryUnit"
      fileName="工伤单位导入模板.xlsx"
      :dialogVisible="UpLoaddialogVisible"
      @close-dialog="closeUpDialog"
      @error="error"
      @success="success"
    ></excel>
  </div>
</template>

<script>
import { Search, Delete } from "@element-plus/icons";
import { InjuryUnitList } from "@/assets/apiData/InjuryUnitList";
import {
  GetDataInjuryUnitList,
  DeleteInjuryUnit,
  ExportInjuryUnit,
} from "@api/ApiInjuryUnit";
import InjuryUnitEdit from "@comp/Basic/InjuryUnitEdit.vue";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      dialogVisible: false,
      UpLoaddialogVisible: false,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,
      Unit: {
        CodeID: "",
        Name: "",
      },
      UnitList: [],
      DataList: [],
    };
  },
  components: {
    InjuryUnitEdit,
    excel,
    Search,
  },
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    importExcel() {
      this.UpLoaddialogVisible = true;
    },
    exportExcel() {
      if (this.multipleSelection.length == 0) {
        try {
          ExportInjuryUnit(this.PageQuery).then((result) => {
            if (result.response.status == 500) {
              this.$message.warning("查询到的数据为空");
            }
          });
        } catch (e) {
          console.log(e);
        }
      } else {
        this.export2Excel();
      }
    },
    error() {},
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
      this.seach();
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径
        const tHeader = [
          ...Enumerable.from(v.UnitList)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(v.UnitList)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名
        const list = v.DataList;
        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `工伤单位`);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleClick(index, type) {
      console.log(index, type);

      this.InjuryUnitEdit(index, type);
    },
    InjuryUnitEdit(index, type) {
      var _this = this;
      if (type == "Delete") {
        DeleteInjuryUnit(_this.DataList[index].id).then(function (data) {
          if (data) {
            _this.$message.success("删除成功");
            _this.PageQuery.pageindex = 1;
            _this.GetData();
          }
        });
      } else {
        _this.dialogVisible = true;
        var id = 0;
        if (type != "Add") id = _this.DataList[index].id;
        _this.$refs.InjuryUnitEdit.loadDataById(id, type);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    add() {
      this.InjuryUnitEdit(-1, "Add");
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },

    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetData();
    },
    GetData() {
      const _this = this;
      this.SearchDataInfo();
      try {
        GetDataInjuryUnitList(_this.PageQuery).then(function (data) {
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        console.log(e);
      }
    },
    SearchDataInfo() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
  },
  created() {
    this.UnitList = InjuryUnitList;
    this.GetData();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
</style>
